import { DatabaseFill } from "@gravity-ui/icons";
import { Button, Icon } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import { useCallback, useMemo } from "react";
import { productSelectionStore } from "src/store/atoms";
import { ShowConfirmDialog } from "src/widgets/Alert/Alert";

import { fillProductSelection } from "../../store";
import { FillConfirm } from "./components";
import css from "./FillProductSelectionButton.module.scss";
import {
  MAX_FILL_PRODUCTS_COUNT,
  fillCountAtom,
} from "./store/atoms/fillCountAtom";

interface FillProductSelectionButtonProps {
  buttonText: string;
}

export const FillProductSelectionButton = ({
  buttonText,
}: FillProductSelectionButtonProps) => {
  const [selectedProductSample] = useAtom(
    productSelectionStore.currentSelectionAtom,
  );
  const fillProductSelectionRequest = useAction(fillProductSelection);
  const [isFillProductSelectionRequestLoading] = useAtom(
    fillProductSelection.isLoadingAtom,
  );

  const [count] = useAtom(fillCountAtom);

  const isDisabled = useMemo(
    () =>
      !selectedProductSample ||
      isFillProductSelectionRequestLoading ||
      selectedProductSample.productIds?.length === MAX_FILL_PRODUCTS_COUNT,
    [selectedProductSample, isFillProductSelectionRequestLoading],
  );

  const handleOnClick = useCallback(() => {
    ShowConfirmDialog(<FillConfirm />, "Подтверждение заполнения").then(
      async (result) => {
        if (result) {
          return fillProductSelectionRequest();
        }
      },
    );
  }, [fillProductSelectionRequest, count]);

  return (
    <Button
      view={"outlined"}
      disabled={isDisabled}
      loading={isFillProductSelectionRequestLoading}
      onClick={handleOnClick}
      title={buttonText}
      className={css.fillProductButton}
    >
      <Icon data={DatabaseFill} />
      {buttonText}
    </Button>
  );
};
